// Format currency amount to string with space for every thousand and comma instead of dot and add kr at the end
const formatCurrencyAmount = (number) => {
  const value = Number(number);

  // null, undefined and non-numeric input fall back to 0
  if (number === null || number === undefined || Number.isNaN(value)) {
    return '0,00 kr';
  }

  // round to two decimals before adding the thousand separators
  const [integer, decimals] = value.toFixed(2).split('.');

  return `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${decimals} kr`;
};

export default formatCurrencyAmount;
